import { Carousel } from "antd";
import React, { memo } from "react";
import { ramanjuneya } from "../../assets/images/tms-image-list";
const TmsCarousel = () => {
  const slides = [{ slide: ramanjuneya, slide_desc: "Samathamurthi" }];
  const contentStyle = {
    height: "100vh",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
    width: "100%",
    objectFit: "cover",
  };
  return (
    <Carousel
      autoplay
      className="autoplay tms-carousel"
      easing
      effect="fade"
      dots={false}
    >
      {/* <div className="tms-carousel-slide" key={`slider-${1}`}>
        <img src={tms_slider_1} style={contentStyle} alt="" />
        <p className="tms-carousel-inner-text" key={`slider-text-${1}`}>
          {" "}
          {slides[0].slide_desc}
        </p>
      </div> */}
      {slides.map((item, i) => {
        return (
          <div className="tms-carousel-slide" key={`slider-${i}`}>
            <img src={item.slide} style={contentStyle} alt="" />
            <p className="tms-carousel-inner-text" key={`slider-text-${i}`}>
              {" "}
              {item.slide_desc}
            </p>
          </div>
        );
      })}
    </Carousel>
  );
};
export default memo(TmsCarousel);
